import { render, staticRenderFns } from "./OtherBackRequest.vue?vue&type=template&id=23f4dd32&scoped=true&"
import script from "./OtherBackRequest.vue?vue&type=script&lang=js&"
export * from "./OtherBackRequest.vue?vue&type=script&lang=js&"
import style0 from "./OtherBackRequest.vue?vue&type=style&index=0&id=23f4dd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4dd32",
  null
  
)

export default component.exports